'use strict';

angular.module('amexReconciliationApp')
  .component('merchantInfo', {
    templateUrl: 'scripts/views/components/merchant-info.html',
    bindings: {
      merchant: '<'
    },
    controller: function () {
      var self = this;
      self.displayCityStateCountry = function () {
        var cityStateCountry = self.merchant.country;
        if (self.merchant.state) {
          cityStateCountry = self.merchant.state + ', ' + cityStateCountry;
        }
        if (self.merchant.city) {
          cityStateCountry = self.merchant.city + ', ' + cityStateCountry;
        }
        return cityStateCountry;
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/merchantInfo.js
// module id = 459
// module chunks = 0